import type { MiddlewareAPI } from 'redux';
import { payloadUtils } from '@makemydeal/dr-shared-ui-utils';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { configureSalesCheckin } from './config';
import { DEFAULT_PROTOCOL } from '@makemydeal/dr-sales-checkin-ui-utils';
import type { MiddlewareManager } from '@makemydeal/dr-sales-checkin-store';
import type { IConfigSalesCheckin } from '@makemydeal/dr-sales-checkin-types';

export let cachedSalesCheckinMiddlewareManager: MiddlewareManager | undefined;

// needed for testing
export const salesCheckinMiddlewareClearCache = () => (cachedSalesCheckinMiddlewareManager = undefined);
type SalesCheckinInitConfig = {
    services: {
        gateway: any;
    };
};

export const salesCheckinMiddleware = (store: MiddlewareAPI) => (next: any) => (action: AnyFSA) => {
    if (action.type === bootstrapActionTypes.BOOTSTRAP_SUCCESS) {
        const featureToggles = payloadUtils.getFeatureTogglesFromInitPayload(action.payload);
        const { services: { gateway } = {} } = payloadUtils.getConfigFromInitPayload<SalesCheckinInitConfig>(action.payload);

        // TODO: fill with necessary config data
        const SalesCheckinConfig = {
            services: {
                gateway
            },
            featureToggles,
            staticImages: {
                protocol: DEFAULT_PROTOCOL,
                host: ''
            }
        } as IConfigSalesCheckin;

        cachedSalesCheckinMiddlewareManager = configureSalesCheckin(SalesCheckinConfig);
    }

    if (cachedSalesCheckinMiddlewareManager) {
        cachedSalesCheckinMiddlewareManager.middleware(store)(next)(action);
    } else {
        next(action);
    }
};
